<template>
  <div :class="['footer', { 'subpage-footer': isSubPage }]">
    <div class="linkBox">
      <div class="content df align-center">
        <img
          v-if="!isSubPage"
          src="@/assets/images/link-logo.png"
          alt=""
          class="logo"
        />
        <img v-else src="@/assets/images/clink-logo.png" alt="" class="logo" />
        <div v-if="!$isMobile" class="linkList">
          <a
            :href="item.linkUrl"
            target="_blank"
            v-for="(item, index) in linkList"
            :key="index"
            >{{ item.linkName }}</a
          >
        </div>
        <div v-else class="linkList">
          <el-input
            v-model="linkValue"
            placeholder="陕西省人民政府网"
            @focus="openDrawer"
            readonly
          ></el-input>

          <!-- 使用Dialog模拟Picker -->
          <el-dialog
            :visible.sync="drawer"
            width="100%"
            center
            :before-close="handleClose"
            custom-class="picker-dialog"
          >
            <div class="picker-content">
              <div class="picker-toolbar">
                <button class="picker-button picker-cancel" @click="onCancel">
                  取消
                </button>
                <div class="picker-title">友情链接</div>
                <button class="picker-button picker-confirm" @click="onConfirm">
                  确认
                </button>
              </div>

              <div class="picker-columns">
                <ul class="picker-list">
                  <li
                    v-for="(item, index) in linkList"
                    :key="item.id"
                    :class="[
                      'picker-option',
                      { selected: selectedIndex === index },
                    ]"
                    @click="selectItem(index, item)"
                  >
                    {{ item.linkName }}
                  </li>
                </ul>
              </div>
            </div>
          </el-dialog>
        </div>
        <!-- <div v-else class="linkList">
          <el-input v-model="linkValue" placeholder="陕西省人民政府网" @focus="openDrawer"></el-input>
          <el-drawer
            title="我是标题"
            :visible.sync="drawer"
            direction="btt"
            :before-close="handleClose">
            <li v-for="item in linkList" :key="item.id">{{ item.linkName }}</li>
          </el-drawer>
        </div> -->
      </div>
    </div>
    <div v-if="!$isMobile" class="footerBox">
      <div class="content df">
        <div class="leftBox">
          <img src="@/assets/images/map.png" alt="" class="mapImg" />
          <div class="left-bot-box df">
            <!-- 下一版显示 -->
            <!-- <li>
              <div class="message df align-center just-center">
                <img src="@/assets/images/customer-service.png" alt="" />
                <div>在线留言</div>
              </div>
            </li> -->
            <li>
              <img src="@/assets/images/qrCode1.png" alt="" class="qrCode" />
            </li>
            <li>
              <img src="@/assets/images/qrCode2.png" alt="" class="qrCode" />
            </li>
            <li>
              <div class="adress">
                <span>客服电话：</span>
                <br />
                <span style="margin-right: 10px">400-968-1018</span>
                <span>029-86615681</span>
                <br />
                <span>地址：</span>
                <br />
                <span>陕西省西安市未央区广运潭大道5555号5号楼</span>
              </div>
            </li>
          </div>
        </div>
        <div class="rightBox">
          <ul class="df just-between">
            <div v-for="(item, index) in menuList" :key="index">
              <div class="title">{{ item.name }}</div>
              <li
                v-for="(subItem, subIndex) in item.subList"
                :key="subIndex"
                class="sub-item"
              >
                <router-link :to="subItem.link">{{ subItem.name }}</router-link>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="footerBox">
      <div class="content df just-between align-center">
        <img src="@/assets/images/map.png" alt="" class="mapImg" />
        <img src="@/assets/images/qrCode2.png" alt="" class="qrCode" />
        <div class="adress">
          <span>客服电话：</span>
          <span style="margin-right: 10px">400-968-1018</span>
          <span>029-86615681</span>
          <br />
          <span>地址：</span>
          <span>陕西省西安市未央区广运潭大道5555号5号楼</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/data/index";
import { friendshipLinkList } from "@/api/link";
export default {
  name: "Footer",
  computed: {
    isSubPage() {
      return this.$route.path.indexOf("/home") === -1;
    },
  },
  data() {
    return {
      linkList: [],
      menuList,
      linkValue: "",
      drawer: false,
      selectedIndex: -1,
      selectedItem: null,
      // menuLists: []
    };
  },
  created() {
    this.getLinkList();
  },
  methods: {
    async getLinkList() {
      const res = await friendshipLinkList();
      if (res.code == 200) {
        this.linkList = res.data;
      }
    },
    openDrawer() {
      this.drawer = true;
    },
    handleClose(done) {
      this.onCancel();
      done();
    },
    selectItem(index, item) {
      this.selectedIndex = index;
      this.selectedItem = item;
    },

    onConfirm() {
      if (this.selectedItem) {
        this.linkValue = this.selectedItem.linkName;
        this.$confirm("即将跳转外部链接", "提示", {
          confirmButtonText: "允许",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.drawer = false;
            window.open(this.selectedItem.linkUrl)
          })
          .catch(() => {
            this.drawer = false;
          });
      }
    },

    onCancel() {
      this.drawer = false;
      this.selectedIndex = -1;
      this.selectedItem = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 1400px;
  margin: 0 auto;
  color: #fff;
}

.linkBox {
  background: #fff;

  .content {
    height: 85px;
  }

  .logo {
    width: 109px;
  }

  .linkList {
    margin-left: 23px;
    text-align: left;

    a {
      color: #6c6969;
      margin-right: 12px;
      font-size: 12px;
    }
  }
}

.footerBox {
  background-image: url("@/assets/images/footer-bg.png");
  padding: 36px 0;

  // .content {
  //   height: 350px;
  // }

  .leftBox {
    width: 640px;

    .mapImg {
      width: 640px;
      height: 196px;
    }

    .left-bot-box {
      margin-top: 12px;

      li {
        margin-right: 24px;
      }

      .message {
        width: 184px;
        height: 60px;
        background: #fff;
        color: #156aa3;
        font-size: 16px;
        font-weight: 600;
        border: 2px solid #156aa3;

        img {
          width: 36px;
          margin-right: 12px;
        }
      }

      .adress {
        text-align: left;
        font-size: 12px;
      }

      .qrCode {
        width: 60px;
        height: 60px;
      }
    }
  }

  .rightBox {
    flex: 1;
    margin-left: 120px;
    text-align: left;

    .title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .sub-item {
      font-size: 14px;
      margin-bottom: 12px;
    }
  }
}
.subpage-footer {
  .linkBox {
    background: #156aa3;
    a {
      color: #e0eaff;
    }
  }
  .footerBox {
    background-image: url("@/assets/images/cfooter-bg.png");
  }
}

@media screen and (max-width: 768px) and (any-hover: none) {
  .content {
    width: 100%;
  }
  .linkBox {
    .content {
      width: calc(100% - 24px - 24px);
      height: 50px;
      .logo {
        width: 65px;
        margin-top: 1%;
      }
      .linkList {
        flex: 1;
        ::v-deep .el-input {
          .el-input__inner {
            height: 30px;
          }
          .el-input__suffix {
            line-height: 30px;
          }
          .el-input__suffix-inner {
            display: inline-block;
          }
          .el-input__icon {
            line-height: inherit;
          }
        }
        ::v-deep .el-drawer__body {
          color: #333;
          text-align: center;
        }
        .el-dialog__wrapper {
          top: auto;
        }
        ::v-deep .picker-dialog {
          margin: 0 auto;
          .picker-content {
            height: 300px;
            display: flex;
            flex-direction: column;
          }

          .picker-toolbar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 16px;
            border-bottom: 1px solid #ebedf0;
            background: #fff;
          }

          .picker-title {
            font-size: 16px;
            font-weight: 500;
            color: #323233;
          }

          .picker-button {
            border: none;
            background: none;
            font-size: 14px;
            padding: 0;
            cursor: pointer;
          }

          .picker-cancel {
            color: #969799;
          }

          .picker-confirm {
            color: #1989fa;
          }

          .picker-columns {
            flex: 1;
            overflow-y: auto;
          }

          .picker-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .picker-option {
            padding: 12px 16px;
            font-size: 14px;
            color: #323233;
            border-bottom: 1px solid #ebedf0;
            cursor: pointer;
            transition: background-color 0.2s;
          }

          .picker-option:hover {
            background-color: #f7f8fa;
          }

          .picker-option.selected {
            color: #1989fa;
            background-color: #f2f8ff;
          }
        }

        /* 自定义Dialog样式 */
        :deep(.picker-dialog .el-dialog__header) {
          display: none;
        }

        :deep(.picker-dialog .el-dialog__body) {
          padding: 0;
        }
      }
    }
  }
  .footerBox {
    padding: 12px;
    .content {
      gap: 10px;
      .mapImg {
        width: 122px;
        height: 30px;
      }
      .qrCode {
        width: 30px;
        height: 30px;
      }
      .adress {
        font-size: 8px;
      }
    }
  }
}
</style>